var _defs, _polygon, _polygon2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVinologix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 93",
    width: 100,
    height: 93,
    role: "img",
    "aria-label": "Wine bottles in a cardboard case",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "face",
    gradientUnits: "userSpaceOnUse",
    x1: 10.4,
    y1: 24.4,
    x2: 37.6,
    y2: 72
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#CC986F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77F4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "side",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 17.6,
    x2: 0,
    y2: 87.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9E613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#804C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804C2D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "frontFace"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "10.4,24.4 68.6,17.6 68.6,87.4 10.4,81"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "68.6,17.6 82.6,29.3 82.6,76.4 68.6,87.4",
    fill: "url(#side)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "10.4,24.4 68.6,17.6 68.6,87.4 10.4,81",
    fill: "url(#face)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#frontFace)",
    fill: "none",
    stroke: "#8A372A",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2 90 L12.22 69 C12.24 68.17 12.26 65.5 12.34 64 C12.42 62.5 12.56 61.17 12.7 60 C12.85 58.83 12.89 58.5 13.19 57 C13.49 55.5 14.21 52.67 14.52 51 C14.83 49.33 14.99 49.17 15.07 47 C15.15 44.83 15.01 39.5 15 38 L15 36.7 Q15 36 15.7 36 L17.85 36 Q18.55 36 18.55 36.7 L18.54 38 C18.55 39.17 18.55 43.33 18.59 45 C18.63 46.67 18.66 46.83 18.81 48 C18.95 49.17 19.11 50.33 19.47 52 C19.83 53.67 20.5 55.83 20.97 58 C21.44 60.17 22.03 63.17 22.28 65 C22.53 66.83 22.46 68.33 22.49 69 L22.85 90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.45 90 L23.11 70 C23.12 69.17 23.11 66.33 23.19 65 C23.26 63.67 23.45 62.83 23.58 62 C23.71 61.17 23.75 60.83 23.97 60 C24.2 59.17 24.72 57.83 24.93 57 C25.14 56.17 25.19 55.33 25.24 55 L25.2 53.7 Q25.2 53 25.9 53 L28 53 Q28.7 53 28.7 53.7 L29.17 55 C29.23 55.33 29.39 56.33 29.56 57 C29.73 57.67 29.96 57.33 30.19 59 C30.42 60.67 30.8 65.17 30.94 67 C31.07 68.83 31 69.5 31.01 70 L31.05 90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.08 90 L31.19 68 C31.2 67.5 31.18 66.33 31.28 65 C31.37 63.67 31.61 61.17 31.77 60 C31.93 58.83 31.97 58.83 32.24 58 C32.5 57.17 33.13 55.67 33.36 55 C33.58 54.33 33.53 54.5 33.58 54 C33.64 53.5 33.68 53.5 33.69 52 C33.7 50.5 33.65 46.17 33.64 45 L33.7 43.7 Q33.7 43 34.4 43 L36.8 43 Q37.5 43 37.5 43.7 L37.49 45 C37.52 46.33 37.57 51.33 37.69 53 C37.82 54.67 37.92 54.17 38.24 55 C38.56 55.83 39.31 57.17 39.64 58 C39.96 58.83 40.04 59 40.18 60 C40.32 61 40.4 62.67 40.46 64 C40.52 65.33 40.52 67.33 40.53 68 L40.87 90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.02 90 L41.02 65 C41.03 64.33 41.02 62 41.05 61 C41.08 60 40.98 60.17 41.21 59 C41.43 57.83 42.17 55.17 42.4 54 C42.64 52.83 42.44 53.17 42.62 52 C42.8 50.83 43.24 48.67 43.48 47 C43.72 45.33 43.94 45.33 44.08 42 C44.21 38.67 44.23 29.5 44.27 27 L44.18 25.7 Q44.18 25 44.88 25 L47.75 25 Q48.45 25 48.45 25.7 L48.21 27 C48.22 27.67 48.18 28.5 48.27 31 C48.36 33.5 48.42 38.67 48.76 42 C49.1 45.33 49.82 48.67 50.3 51 C50.78 53.33 51.31 54.33 51.63 56 C51.94 57.67 52.06 59.5 52.17 61 C52.28 62.5 52.27 64.33 52.3 65 L52.67 90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.05 90 L53.05 67 C53.06 65.83 53.04 61.83 53.1 60 C53.16 58.17 53.28 57 53.42 56 C53.57 55 53.57 55 53.97 54 C54.38 53 55.49 51 55.87 50 C56.25 49 56.19 49.83 56.26 48 C56.33 46.17 56.27 40.5 56.27 39 L56.28 37.7 Q56.28 37 56.98 37 L59.85 37 Q60.55 37 60.55 37.7 L60.21 39 C60.27 40.5 60.49 46.33 60.58 48 C60.67 49.67 60.59 48.5 60.74 49 C60.89 49.5 61.09 50.17 61.46 51 C61.83 51.83 62.63 53.17 62.96 54 C63.29 54.83 63.31 53.83 63.43 56 C63.55 58.17 63.64 65.17 63.69 67 L63.7 90"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinologix);
export default __webpack_public_path__ + "static/media/vinologix.7bb77ca44e56cf038d5b781b9ae6aeae.svg";
export { ForwardRef as ReactComponent };